import { Instagram, Facebook, Linkedin, Youtube, Mail } from "lucide-react";
import logo from "@/assets/logo-coressen-white.svg";

const socialLinks = [
  {
    name: "Instagram",
    icon: Instagram,
    url: "https://www.instagram.com/coressenglobal",
  },
  {
    name: "Facebook",
    icon: Facebook,
    url: "https://www.facebook.com/coressenglobal",
  },
  {
    name: "LinkedIn",
    icon: Linkedin,
    url: "https://www.linkedin.com/company/coressenglobal",
  },
  {
    name: "YouTube",
    icon: Youtube,
    url: "https://www.youtube.com/@coressenglobal",
  },
];

// TikTok icon component (not available in Lucide)
const TikTokIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="text-white py-12 md:py-16 border-t border-white/10"
      style={{ background: "hsl(220 69% 2%)" }}
    >
      <div className="container px-4">
        <div className="flex flex-col items-center gap-8">
          {/* Logo */}
          <a href="#hero" className="hover:opacity-80 transition-opacity">
            <img src={logo} alt="CORESSEN" className="h-12 md:h-16 w-auto" />
          </a>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.name}
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white/70 hover:bg-[hsl(216_38%_33%)] hover:text-white transition-all duration-300 hover:scale-110"
              >
                <social.icon className="w-5 h-5" />
              </a>
            ))}
            {/* TikTok */}
            <a
              href="https://www.tiktok.com/@coressenglobal"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
              className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white/70 hover:bg-[hsl(216_38%_33%)] hover:text-white transition-all duration-300 hover:scale-110"
            >
              <TikTokIcon className="w-5 h-5" />
            </a>
          </div>

          {/* Email */}
          <a
            href="mailto:hola@coressenglobal.com"
            className="flex items-center gap-2 text-white/70 hover:text-[hsl(216_32%_52%)] transition-colors"
          >
            <Mail className="w-4 h-4" />
            <span className="text-sm">hola@coressenglobal.com</span>
          </a>

          {/* Tagline */}
          <p className="text-sm text-white/50 text-center">
            BrandWay© para marcas con trayectoria decididas a escalar
          </p>

          {/* Divider */}
          <div className="w-full max-w-md h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />

          {/* Copyright */}
          <div className="text-center text-xs text-white/70">
            <p>© {currentYear} CORESSEN®. Todos los derechos reservados.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
